export default {
  USER_ACCESS_TOKEN: 'app_usr_ac_tk',
};
